export default "/_next/static/images/roger-lee-d87d8bd22c896f3e29bb3b93bb281b0a.png";